<div *ngIf="loader==false">
    <div class="col-12 col-md-12 col-lg-12 col-xl-12 pl-0">
        <div id="main2" style="transition: 1s" class="vh-100 no-padding" [ngClass]="{'col-10':!sidebarState,'col-sm-11':!sidebarState,'col-md-9':!sidebarState,'col-lg-10':!sidebarState,'col-xl-10':!sidebarState,
    'col-12':sidebarState,'col-sm-12':sidebarState,'col-md-12':sidebarState,'col-lg-12':sidebarState,'col-xl-12':sidebarState
    }">
            <ng-scrollbar #scrollable
                          [disableOnBreakpoints]="false">
                <div class="col-12 col-sm-12 col-md-12  col-lg-6 col-xl-6 " id="main" style="max-height: 90vh; overflow-y: scroll;">

                    <div *ngIf="loader==false && task !== undefined"
                         class="container  no-padding-left">

                        <div class="px-0 col-11 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-4">


                            <div class="col-9 col-sm-8 col-md-8 col-xl-8 col-lg-8">

                                <div class="col-md-12 col-lg-12 col-xl-12" style="display: -webkit-box">


                                    <h2 class="mt-1 font-weight-bold d-table">
                                        <span class="badge badge-light d-inline">#{{identifier}}</span>  {{title}}</h2>
                                    <div class="d-inline-block">
                                        <button class="ui-btn-inline"
                                                style="color: black;padding-left: 6px;bottom: 10%;box-shadow: none;outline: none"
                                                [disabled]="validatorPermission===false || (task['created_by'] != creator && task['type']=='meeting')"
                                                (click)="sort==='task'? editTask(taskId): editSubtask(taskId) "
                                                mat-icon-button title="Izmijeni task">
                                            <mat-icon style="font-size: 17px">edit</mat-icon>
                                        </button>
                                        <button class="ui-btn-inline" [disabled]="validatorPermission==false"
                                                (click)="deleteTask(taskId)"
                                                style="color: black;padding-left: 0;bottom: 10%;"
                                                mat-icon-button title="Izbriši task">
                                            <mat-icon style="font-size: 17px">delete</mat-icon>

                                        </button>
                                        <button style="color: black;padding-left: 0;bottom: 10%;"
                                                [disabled]="buttonDisabled" *ngIf="eye==false"
                                                class="ui-btn-inline"
                                                mat-icon-button
                                                title="Prati zadatak"
                                                (click)="setWatcher(taskId)"><i
                                                class="fa fa-eye"></i>
                                        </button>
                                        <button style="color: black;padding-left: 0;bottom: 10%;"
                                                [disabled]="buttonDisabled" *ngIf="eye==true"
                                                class="ui-btn-inline"
                                                mat-icon-button
                                                title="Ne prati"
                                                (click)="removeWatcher(taskId)"><i
                                                class="fa fa-eye-slash"></i>
                                        </button>
                                    </div>


                                </div>
                                <div class="col-md-12 col-lg-12 col-xl-12">
                                    <p style="    font-size: 12px;">
                                        Kreirao/la {{taskCreatorData[0]['first_name'] + ' ' + taskCreatorData[0]['last_name']}}
                                        , {{createdAtString}}</p>

                                </div>
                            </div>

                            <div
                                    id="validationButtons"
                                    class="col-3 col-sm-4 col-md-4 col-lg-4 col-xl-4  no-padding mt-1 text-right">
                                <button *ngIf="(validatorPermission===true && task['status'] =='ddone' && task['track']==='ddone')"
                                        [ngStyle]="{'display':(validatorPermission===true && task['status'] !=='validated' && task['track']==='ddone')? 'auto':'none'  }"
                                        style="border-radius: 35px;
                background: #ffab36;
                 border-color: #ffab36;font-size: 12px;" class="btn btn-primary btn-sm" type="button"
                                        (click)="validateTask(false)">
                                    Vrati zadatak
                                </button>
                                <button *ngIf="(validatorPermission===true && task['status'] =='ddone' && task['track']==='ddone')"
                                        [ngStyle]="{'display':(validatorPermission===true && task['status'] !=='validated' && task['track']==='ddone')? 'auto':'none'  }"
                                        style="    border-radius: 35px;background: #55c579;
                 border-color: #55c579;font-size: 12px;" class="btn btn-primary ml-2 btn-sm" type="button"
                                        (click)="validateTask(true)">
                                    Odobri
                                </button>
                                <button [ngStyle]="{'margin-top':(validatorPermission===true && task['status'] !=='validated' && task['track']==='ddone') ? '5px':''}"
                                        [ngClass]="buttonClass" (click)=select.open()
                                        class="btn btn-primary ml-2 btn-sm"
                                        style="font-size: 12px;"
                                        type="button">
                                    {{statusName}}
                                </button>
                                <mat-select #select
                                            [disabled]="(task['track']==='ddone' && !validatorPermission) ||
                                             (task['status']=='validated' || task['status']=='deleted')
                                            || (statusName==='Završeno' && !validatorPermission) || !permission
                                            "
                                            (selectionChange)="changeTaskStatus($event, taskId)"
                                            style="color: white;margin-right: 15px;visibility: hidden" [value]="status">
                                    <mat-option value="todo">
                                        Otvoren
                                    </mat-option>
                                    <mat-option value="inprogress">
                                        U radu
                                    </mat-option>
                                    <mat-option [disabled]="!validatorPermission" value="canceled">
                                        Otkazano
                                    </mat-option>
                                    <mat-option [disabled]="!validatorPermission" value="postponed">
                                        Odloženo
                                    </mat-option>
                                    <mat-option value="ddone">
                                        Završeno
                                    </mat-option>
                                    <mat-option disabled value="validated">
                                        Odobren
                                    </mat-option>
                                    <mat-option disabled value="deleted">
                                        Izbrisan
                                    </mat-option>
                                </mat-select>
                            </div>

                            <div id="mainPreviewDetails"
                                 class="col-md-12 col-lg-12 col-xl-12 pr-0 mt-4 table-responsive">

                                <table id="mainTable" class="table  table-main-details">
                                    <thead>
                                    <tr>
                                        <th *ngIf="type=='task' ||type=='meeting'" style="padding-left: 2rem;"
                                            scope="col">
                                            {{type == 'task' ? 'IZVRŠILAC' : 'UČESNICI'}}
                                        </th>
                                        <th *ngIf="type=='task'" scope="col">ROK</th>
                                        <th *ngIf="type=='meeting'" scope="col">POČETAK SASTANKA</th>
                                        <th *ngIf="type=='meeting'" scope="col">KRAJ SASTANKA</th>
                                        <th *ngIf="type=='reminder'" scope="col">DATUM PODSJETNIKA</th>
                                        <th scope="col">TAG</th>
                                        <th *ngIf="type=='task'" scope="col">POSMATRAČI</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <td style="padding-left:2rem;color:black;margin-top: 7px" *ngIf="type==='task'"
                                            scope="row">
                                            <div *ngFor="let i of assignedForTask">
                                                <div>
                                                    <app-avatar personalStyle="margin-left:3px" [assigned]="i"
                                                                personalStyle="box-shadow: 0;"
                                                                avatarWidth="30"></app-avatar>
                                                    <label style="    width: 1%;
    display: table-cell;
    margin-left: 30px;
    /*padding-top: 6px;*/
    padding-left: 6px;"
                                                           class=" mt-1 label-assigned">{{i['first_name'] + ' ' + i['last_name']}}</label>
                                                </div>

                                            </div>
                                        </td>
                                        <td *ngIf="type==='meeting'" style="color:black;display: flex;" scope="row">
                                            <div *ngFor="let i of assignedForTask">
                                                <app-avatar [assigned]="i" personalStyle="box-shadow: 0;left: -3%"
                                                            avatarWidth="30"></app-avatar>
                                                <label style="width: 1%;display: grid;margin-left: 30px;"
                                                       class=" mt-1 label-assigned"></label>
                                            </div>
                                        </td>

                                        <td *ngIf="type==='meeting'"
                                            style="color:black">{{getDateStringInLocalLang(meetingTime.start)}}</td>
                                        <td *ngIf="type==='meeting'"
                                            style="color:black">{{getDateStringInLocalLang(meetingTime.end)}}</td>
                                        <td *ngIf="type==='reminder'"
                                            style="color:black">{{getDateStringInLocalLang(reminderTime.start)}}</td>

                                        <td *ngIf="type=='task'"
                                            style="color:black">{{getDateStringInLocalLang(deadline)}}</td>
                                        <td [ngStyle]="{'display': hashes.length !==0 ?'grid':''}"><span
                                                *ngFor="let tag of hashes; index as i" style="background-color: #8d4ab2;
    font-size: 11px;
    border-radius: 10px;overflow: hidden;text-overflow: ellipsis;padding: 2px 15px;"
                                                class="badge badge-primary text-uppercase"
                                                [ngClass]="{' mt-1': i>0}">{{tag}}</span>
                                            <span *ngIf="hashes.length==0" style="background-color: #8d4ab2;
    font-size: 11px;
    border-radius: 10px;overflow: hidden;text-overflow: ellipsis;padding: 2px 15px;"
                                                  class="badge badge-primary text-uppercase">nema tagova</span>

                                        </td>
                                        <td *ngIf="type =='task'">
                                            <div *ngFor="let watcher of watchers">
                                                <app-avatar personalStyle="margin-left:3px" [assigned]="watcher"
                                                            avatarWidth="30"></app-avatar>
                                            </div>

                                            <div *ngIf="watchers.length==0">
                            <span style="background-color: #87ceeb;
    font-size: 11px;
    border-radius: 10px;overflow: hidden;
    text-overflow: ellipsis;
    padding: 2px 15px;" class="badge badge-info text-uppercase">Nema posmatraca</span>
                                            </div>

                                        </td>
                                    </tr>
                                    </tbody>
                                </table>

                            </div>

                            <div style="    border-bottom: 1px solid #eaeaea;" id="description"
                                 class="col-md-12 col-lg-12 col-xl-12 mt-1  pb-4">
                                <div class="col-12 pl-0"><label style="    font-size: 16px;
    font-weight: 600;">OPIS</label>
                                    <p *ngIf="description !==''" class="mt-4"
                                       style="letter-spacing: 0.4px;font-size: 14px;">{{description}}</p>
                                    <p *ngIf="description===''" class="mt-1"
                                       style="letter-spacing: 0.4px;font-size: 14px;color: #8080806b;">Nema opisa.</p>

                                </div>


                            </div>
                            <div id="attachmentsSection" class="col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-4">
                                <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6" *ngFor="let item of attachments">
                                    <app-attachment-thumbnails [removePermission]="false"
                                                               [attachment]="item"></app-attachment-thumbnails>
                                </div>


                            </div>

                            <div id="commentsSection" class="col-md-12 col-lg-12 col-xl-12 mt-4">

                                <div class="col-12 pl-0"><label class="text-uppercase" style="    font-size: 16px;
    font-weight: 600;">Komentari</label>

                                    <div class="container mb-5 mt-4 pl-2 pr-0">


                                        <div id="addingComment" class="media">
                                            <app-avatar avatarWidth="50" [assigned]="user"
                                                        personalStyle=""></app-avatar>
                                            <div class="media-body ml-2">
                                                <div class="col-12 no-padding">
                                                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 no-padding  containe">
                                                        <div class="input-group">
                                        <textarea
                                            #autoResizedTextArea
                                            [ngStyle]="tabs" class="form-control" aria-label="With textarea"
                                            [(ngModel)]="commentText"
                                            (ngModelChange)="resizedTextAreaHandler()"
                                            style="border: none;outline: none;background: #eaeaea;border-radius: 9px;"
                                            (keydown.enter)="addComment()"
                                            placeholder="+ tekst komentara"

                                        ></textarea>
                                                            <div class="input-group-prepend">
                                                                <button title="Dodaj dokument" (click)="onClick()"
                                                                        style="    background-color: #ffffff;
    font-size: 20px;
    border-radius: 10px;
    border-color: #ffff;" type="button" class=" btn btn-primar"><i
                                                                        class="fa fa-paperclip"></i>

                                                                </button>
                                                                <button title="Dodaj komentar"
                                                                        [disabled]="commentText =='' && commentAttachments.length==0"
                                                                        (click)="addComment()"
                                                                        style="    background-color: #ffffff;
    font-size: 20px;
    border-radius: 10px;
    border-color: #ffff;" type="button" class="ml-2 btn btn-primar"><i
                                                                        class="fa fa-check"></i>
                                                                </button>
                                                                <input type="file"
                                                                       style="display: none"
                                                                       multiple="multiple"
                                                                       id="fileUpload" name="fileUpload[]"
                                                                       (change)="upload($event)"
                                                                       #fileUpload>
                                                            </div>

                                                        </div>


                                                    </div>
                                                    <div id="newCommentAttachments"
                                                         class="col-sm-12 col-12 no-padding-left">
                                                        <div class="pl-0 col-sm-6 col-md-6 col-lg-6 col-xl-6"
                                                             *ngFor="let item of commentAttachments">
                                                            <app-attachment-thumbnails
                                                                    (deleteFileEmitter)="deleteFileHandler($event)"
                                                                    [removePermission]="true"
                                                                    [attachment]="item"></app-attachment-thumbnails>
                                                        </div>
                                                    </div>


                                                </div>
                                            </div>
                                        </div>


                                        <div class="card2 mt-3">
                                            <div class="row">
                                                <div class="col-md-12">
                                                    <div class="row">
                                                        <div class="col-md-12">
                                                            <app-comment-item class="commentItem"
                                                                              [commentData]="comment"
                                                                              *ngFor="let comment of commentsArray">

                                                            </app-comment-item>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                </div>

                            </div>


                        </div>


                    </div>
                </div>
                <!--<div >-->
                <div class="subtasks"
                     *ngIf="(loader==false && task !== undefined) && (type !=='reminder' && type!=='note')"
                     class="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 j mt-4 no-padding-right">
                    <div class="col-12">
                        <div class="col-md-8 col-lg-6 col-xl-6">
                            <h3 style="    font-weight: 600;">Podtaskovi</h3>
                        </div>
                        <div class="col-md-4 col-lg-6 col-xl-6 text-right no-padding">
                            <button *ngIf="sort==='task' && type !=='reminder' && type!=='note'"
                                    (click)="addSubtask(taskId)"
                                    style="    border-radius: 35px;background: #55c579;
                 border-color: #55c579;font-size: 12px;" class="btn btn-primary ml-2 btn-sm" type="button">+ Dodaj
                            </button>
                        </div>

                    </div>
                    <div *ngIf="subtasks.length>0" class="col-12">
                        <app-task-minimized style="width: 100%" [task]="subtask"
                                            *ngFor="let subtask of subtasks" [emptyTask]="false">

                        </app-task-minimized>
                    </div>
                    <div *ngIf="subtasks.length==0" class="col-12">
                        <app-task-minimized style="width: 100%"
                                            [emptyTask]="true">

                        </app-task-minimized>
                    </div>


                </div>
                <!--</div>-->

                <div *ngIf="loader==false && task !== undefined" id="task-tabss"
                     class="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3  mt-4  float-right">

                    <div id="task-preview" class="taskPreview">
                        <label class="pl-4"><h3 style="    font-weight: 600;">Detalji</h3></label>
                        <tabset>

                            <tab>
                                <ng-template tabHeading>
                                    Detalji
                                </ng-template>

                                <div class="well-done-heading-task-view">

                                    <div *ngIf="type=='task'||type=='meeting' "
                                         class="col-md-12 well-done-task-view-block">
                                        <h3 class="no-margin">Izvršilac</h3>
                                        <div style="display: inline-block"
                                             *ngFor="let item of assignedForTask;index as i">
                                            <div class="media">
                                                <app-avatar [personalStyle]="'margin-top:3px'" [assigned]="item"
                                                            [avatarWidth]="30"></app-avatar>
                                                <div class="media-body mt-2 ml-2">
                                                    {{item['first_name'] + ' ' + item['last_name']}}
                                                </div>

                                            </div>
                                        </div>

                                    </div>


                                    <div *ngIf="type=='task' " class="col-md-12 well-done-task-view-block">
                                        <h3 class="no-margin">{{taskValidators.length == 1 ? 'Validator' : 'Validatori'}}</h3>
                                        <div style="display: inline-block;width: 100%" *ngFor="let i of validatorsData">
                                            <div class="media">
                                                <app-avatar [personalStyle]="'margin-top:3px'" [assigned]="i"
                                                            [avatarWidth]="30"></app-avatar>
                                                <div class="media-body mt-2 ml-2">
                                                    {{i['first_name'] + ' ' + i['last_name']}}
                                                </div>

                                            </div>
                                        </div>
                                    </div>


                                    <div *ngIf="taskCreatorData.length>0" class="col-md-12 well-done-task-view-block">
                                        <h3 class="no-margin">Kreirao/la:</h3>
                                        <!--<span>{{taskCreatorData[0]['first_name'] + ' ' + taskCreatorData[0]['last_name']}}</span>-->
                                        <div style="display: inline-block">
                                            <div class="media">
                                                <app-avatar [personalStyle]="'margin-top:3px'"
                                                            [assigned]="taskCreatorData[0]"
                                                            [avatarWidth]="30"></app-avatar>
                                                <div class="media-body mt-2 ml-2">
                                                    {{taskCreatorData[0]['first_name'] + ' ' + taskCreatorData[0]['last_name']}}
                                                </div>

                                            </div>
                                        </div>
                                    </div>


                                    <div *ngIf="(type=='task'||type=='meeting') && task['project_id'] "
                                         class="col-md-12 well-done-task-view-block">
                                        <h3 class="no-margin">Projekat</h3>
                                        <span>{{task['project']['name']}}
</span>
                                    </div>
                                    <div *ngIf="(type=='task')"
                                         class="col-md-12 well-done-task-view-block">
                                        <h3 class="no-margin">Rok za izvršenje</h3>
                                        <span><i class="lni lni-calendar"
                                                 style="font-size: 17px;"></i> {{deadline | date: 'dd.MM.yyyy HH:mm'}}h
</span>
                                    </div>
                                    <div *ngIf="(type=='meeting')"
                                         class="col-md-12 well-done-task-view-block">
                                        <h3 class="no-margin">Planirano vrijeme početka</h3>
                                        <span><i class="lni lni-calendar"
                                                 style="font-size: 17px;"></i> {{meetingTime.start | date: 'dd.MM.yyyy HH:mm'}}
                                            h
</span>
                                    </div>
                                    <div *ngIf="(type=='meeting')"
                                         class="col-md-12 well-done-task-view-block">
                                        <h3 class="no-margin">Planirano vrijeme završetka</h3>
                                        <span><i class="lni lni-calendar"
                                                 style="font-size: 17px;"></i> {{meetingTime.end | date: 'dd.MM.yyyy HH:mm'}}
                                            h
</span>
                                    </div>

<!--                                  ovdje se radi za trackTime-->

                                    <div *ngIf="(type=='task')" class="col-md-12 well-done-task-view-block">
                                        <h3 class="no-margin">Trajanje izvršavanja</h3>
                                        <span> {{trackTime == '' ? '0 min' : trackTime}}</span>
                                    </div>
                                    <div *ngIf="(type=='task'||type=='meeting') &&endTime !=null "
                                         class="col-md-12 well-done-task-view-block">
                                        <h3 class="no-margin">Vrijeme realizacije</h3>
                                        <span><i class="lni lni-calendar"
                                                 style="font-size: 17px;"></i> {{endTime | date:'dd.MM.yyyy H:mm'}}</span>
                                    </div>
                                    <div *ngIf="(type=='reminder')"
                                         class="col-md-12 well-done-task-view-block">
                                        <h3 class="no-margin">Vrijeme podsjetnika</h3>
                                        <span><i class="lni lni-calendar"
                                                 style="font-size: 17px;"></i> {{reminderTime.start | date: 'dd.MM.yyyy H:mm'}}
                                            h</span>
                                    </div>
                                    <div *ngIf="(type=='task') && execution !==null"
                                         class="col-md-12 well-done-task-view-block">
                                        <h3 class="no-margin">Datum početka</h3>
                                        <span><i class="lni lni-calendar"
                                                 style="font-size: 17px;"></i> {{execution | date: 'dd.MM.yyyy H:mm'}}
                                            h</span>
                                    </div>
                                    <div *ngIf="(type=='task' && status==='ddone' || status==='validated')"
                                         class="col-md-12 well-done-task-view-block">
                                        <h3 class="no-margin">Datum završetka</h3>
                                        <span> <i class="lni lni-calendar"
                                                  style="font-size: 17px;"></i> {{task['end_time'] != null ? (task['end_time']  | date: 'dd.MM.yyyy HH:mm') + 'h' : '/'}}
</span>
                                    </div>
                                    <div class="col-md-12 well-done-task-view-block">
                                        <h3 class="no-margin">Kreirano</h3>
                                        <span><i class="lni lni-calendar"
                                                 style="font-size: 17px;"></i> {{createdAt | date: 'dd.MM.yyyy HH:mm'}}h</span>
                                    </div>


                                </div>

                            </tab>
                            <tab>
                                <ng-template class="ml-2" tabHeading title="watchers">
                                    Posmatrači
                                </ng-template>
                                <ng-container>
                                    <small *ngIf="watchers.length==0">Nema posmatraca.</small>

                                    <table style="background: white" *ngIf="previewTableWatchers" cellspacing="20px">
                                        <tr class="rows" *ngFor="let wat of watchers">

                                            <td>
                                                <app-avatar [avatarWidth]="35" [assigned]="wat"></app-avatar>
                                            </td>
                                            <td style="width:300px;padding: 5px;margin-left: 18px">

                                                {{wat.first_name}}  {{wat.last_name}}
                                            </td>
                                        </tr>
                                    </table>
                                </ng-container>
                            </tab>
                            <tab>
                                <ng-template tabHeading title="history">
                                    Istorija
                                </ng-template>
                                <ng-container>
                                    <small *ngIf="history.length==0 ">Nema istorije zadatka.</small>
                                    <div class="full-width well-done-task-view-block" *ngIf="history.length !==0">
                                        <h3 class="no-margin">Istorija zadatka </h3>
                                        <ul class="pl-1" *ngFor="let it of history">
                                            <li style="font-size: 13px;">{{it.description}}</li>
                                        </ul>
                                    </div>
                                </ng-container>
                            </tab>
                        </tabset>
                    </div>
                </div>

            </ng-scrollbar>
        </div>
    </div>
</div>

